<template>
  <div class="template-library-view">
    <TemplateManager />
  </div>
</template>

<script setup>
import TemplateManager from '@/components/template-library/TemplateManager.vue';
</script>

<style scoped>
.template-library-view {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>